import { render, staticRenderFns } from "./SmsAuthentication.vue?vue&type=template&id=ee4ba0d0&scoped=true"
import script from "./SmsAuthentication.vue?vue&type=script&lang=ts"
export * from "./SmsAuthentication.vue?vue&type=script&lang=ts"
import style0 from "./SmsAuthentication.vue?vue&type=style&index=0&id=ee4ba0d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4ba0d0",
  null
  
)

export default component.exports